import { Radio, ListChecks, ShieldOff, MonitorPlay } from "lucide-react";
import { ONLINE_DIFFERENTIATORS } from "@/lib/content";
import { Reveal, SectionLabel } from "@/components/landing/Reveal";

const iconMap = { live: Radio, plan: ListChecks, notips: ShieldOff, online: MonitorPlay };

export const OnlineDifferent = () => (
  <section
    className="relative bg-ink2 px-4 py-16 diag-grid sm:px-8 lg:py-24"
    data-testid="online-different-section"
  >
    <div className="mx-auto max-w-6xl">
      <Reveal className="max-w-3xl">
        <SectionLabel>What Makes Us Different</SectionLabel>
        <h2 className="mt-4 font-display text-5xl font-bold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-6xl">
          Not Another Recorded Course.{" "}
          <span className="text-em2">A 90-Day Path to Your First 10 Planned Trades.</span>
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2">
        {ONLINE_DIFFERENTIATORS.map((d, i) => {
          const Icon = iconMap[d.icon];
          return (
            <Reveal key={d.title} delay={i * 0.08}>
              <div className="card-surface group flex h-full items-start gap-5 rounded-2xl p-6 sm:p-7">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-em2/25 bg-em1/10 text-em2 transition-transform duration-300 group-hover:scale-110">
                  <Icon size={26} strokeWidth={1.6} />
                </div>
                <div>
                  <h3 className="font-heading text-xl font-bold text-offwhite">{d.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-mutedgreen">{d.body}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
